export default __webpack_public_path__ + "assets/images/a5c628f820a6e0adc4289e3cd4d23247.png";